import $ from 'jquery';

export default class IsInViewport {
	constructor(objectCollection, percentVisible = 100) {
		this.objectCollection = objectCollection;
		this.percentVisible = percentVisible;
	}

	checkDomElement(element) {
		const rect = element.getBoundingClientRect();
		const windowHeight =
			window.innerHeight || document.documentElement.clientHeight;

		return !(
			Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100) <
				this.percentVisible ||
			Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) <
				this.percentVisible
		);
	}

	updatejQueryObject(object, index) {
		if (this.checkDomElement(object)) {
			object.classList.add('active');
			const event = new Event('isInViewport', { bubbles: true }); // (2)
			object.dispatchEvent(event);
			delete this.objectCollection[index];
		}
	}

	update() {
		this.objectCollection.forEach((object, index) => {
			this.updatejQueryObject(object, index);
		});
	}
}
